/**
 * @GENERATED from Figma node 3622:51719
 */

import { useUniqueInlineId } from "@inline-svg-unique-id/react";
import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const MsSuiteDark = function (props: IconProps, ref: React.Ref<SVGSVGElement>) {
  const _id10 = useUniqueInlineId();
  const _id9 = useUniqueInlineId();
  const _id8 = useUniqueInlineId();
  const _id7 = useUniqueInlineId();
  const _id6 = useUniqueInlineId();
  const _id5 = useUniqueInlineId();
  const _id4 = useUniqueInlineId();
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      ref={ref}
      {...props}
    >
      <path fill="#F35325" d="M2.141 1.891h3.914v3.913H2.14z" />
      <path fill="#81BC06" d="M6.446 1.891h3.913v3.913H6.446z" />
      <path fill="#05A6F0" d="M2.141 6.196h3.913v3.913H2.141z" />
      <path fill="#FFBA08" d="M6.446 6.196h3.913v3.913H6.446z" />
      <path
        fill="#1066B5"
        d="M16.61 2.792a.73.73 0 0 1 .729-.73h4.01a.73.73 0 0 1 .73.73V8.99a.73.73 0 0 1-.73.729h-4.01a.73.73 0 0 1-.73-.73z"
      />
      <path
        fill={`url(#${_id})`}
        d="M16.61 2.792a.73.73 0 0 1 .729-.73h4.01a.73.73 0 0 1 .73.73V8.99a.73.73 0 0 1-.73.729h-4.01a.73.73 0 0 1-.73-.73z"
      />
      <path fill="#32A9E7" d="M19.344 5.708h2.734v2.917h-2.734z" />
      <path fill="#167EB4" d="M16.609 5.708h2.734v2.917h-2.734z" />
      <path
        fill="#135298"
        d="M22.38 5.526c.158.123.223.38.223.38l-.525.29v-.83c.04 0 .145.037.303.16"
      />
      <path
        fill={`url(#${_id2})`}
        d="M22.443 9.47a.9.9 0 0 0 .182-.48V6.073s0-.146-.022-.168c-.019.013-.018.008-.018.008l-6.34 3.55s0 .037.182.161c.19.095.365.095.365.095h5.104s.342.003.547-.248"
      />
      <path
        fill={`url(#${_id3})`}
        d="M16.234 9.464c-.172-.24-.172-.474-.172-.474v-3.1l6.388 3.574s-.07.092-.19.156c-.182.099-.364.099-.364.099h-5.104s-.39-.026-.558-.255"
      />
      <path fill="#58D9FD" d="M19.344 2.792h2.734v2.917h-2.734z" />
      <path fill="#32A9E7" d="M16.609 2.792h2.734v2.917h-2.734z" />
      <path
        fill="#000"
        fillOpacity={0.3}
        d="M16.063 5.07c0-.604.49-1.093 1.093-1.093h1.094c.604 0 1.094.49 1.094 1.093v2.735c0 .604-.49 1.093-1.094 1.093h-2.187z"
      />
      <path
        fill={`url(#${_id4})`}
        d="M13.875 4.25a.73.73 0 0 1 .73-.73h3.645a.73.73 0 0 1 .73.73v3.646a.73.73 0 0 1-.73.729h-3.646a.73.73 0 0 1-.729-.73z"
      />
      <path
        fill="#fff"
        d="M17.703 5.91v-.046c0-.788-.567-1.34-1.363-1.34-.8 0-1.371.556-1.371 1.348v.045c0 .788.567 1.34 1.367 1.34.796 0 1.367-.556 1.367-1.347m-.645.007c0 .523-.294.837-.718.837s-.722-.322-.722-.844v-.046c0-.523.294-.837.718-.837.42 0 .723.322.723.845z"
      />
      <path
        fill={`url(#${_id5})`}
        d="M3.793 20.953a2.37 2.37 0 0 1-1.828-.851l4.9-2.056 3.809 2.144c-.336.438-.843.763-1.416.76-.865.003-4.192.003-5.465.003"
      />
      <path
        fill={`url(#${_id6})`}
        d="m9.13 17.138-2.266.907 3.81 2.145c.244-.318.389-.713.389-1.142 0-1.047-.863-1.897-1.93-1.905z"
      />
      <path
        fill={`url(#${_id7})`}
        d="m3.563 16.352 3.302 1.694 2.266-.908c-.323-1.264-1.49-2.2-2.88-2.2a2.98 2.98 0 0 0-2.543 1.405 3 3 0 0 0-.145.009"
      />
      <path
        fill={`url(#${_id8})`}
        d="m1.965 20.102 4.9-2.056-3.303-1.694c-1.192.113-2.124 1.098-2.124 2.295 0 .552.197 1.058.527 1.455"
      />
      <path
        fill={`url(#${_id9})`}
        d="M22.188 15.813h-7.875V14.5c0-.242.195-.437.437-.437h7c.242 0 .438.195.438.437z"
      />
      <path
        fill={`url(#${_id10})`}
        d="M14.313 15.812V21.5c0 .242.195.437.437.437h7a.437.437 0 0 0 .438-.437v-5.688z"
      />
      <path
        fill="#fff"
        d="M17.594 17.781h-.438a.22.22 0 0 1-.218-.218v-.438c0-.12.098-.219.218-.219h.438c.12 0 .218.098.218.219v.438c0 .12-.098.218-.218.218M19.344 17.781h-.438a.22.22 0 0 1-.218-.218v-.438c0-.12.098-.219.218-.219h.438c.12 0 .218.098.218.219v.438c0 .12-.098.218-.218.218M21.094 17.781h-.438a.22.22 0 0 1-.218-.218v-.438c0-.12.098-.219.218-.219h.438c.12 0 .218.098.218.219v.438c0 .12-.098.218-.218.218M17.594 19.313h-.438a.22.22 0 0 1-.218-.22v-.437c0-.12.098-.218.218-.218h.438c.12 0 .218.098.218.218v.438c0 .12-.098.218-.218.218M15.844 19.313h-.438a.22.22 0 0 1-.219-.22v-.437c0-.12.099-.218.22-.218h.437c.12 0 .219.098.219.218v.438c0 .12-.098.218-.22.218M19.344 19.313h-.438a.22.22 0 0 1-.218-.22v-.437c0-.12.098-.218.218-.218h.438c.12 0 .218.098.218.218v.438c0 .12-.098.218-.218.218M17.594 20.844h-.438a.22.22 0 0 1-.218-.219v-.437c0-.121.098-.22.218-.22h.438c.12 0 .218.099.218.22v.437c0 .12-.098.219-.218.219M15.844 20.844h-.438a.22.22 0 0 1-.219-.219v-.437c0-.121.099-.22.22-.22h.437c.12 0 .219.099.219.22v.437c0 .12-.098.219-.22.219M19.344 20.844h-.438a.22.22 0 0 1-.218-.219v-.437c0-.121.098-.22.218-.22h.438c.12 0 .218.099.218.22v.437c0 .12-.098.219-.218.219M21.094 19.313h-.438a.22.22 0 0 1-.218-.22v-.437c0-.12.098-.218.218-.218h.438c.12 0 .218.098.218.218v.438c0 .12-.098.218-.218.218"
      />
      <path
        fill="#000"
        d="M16.063 14.063v.765a.11.11 0 0 1-.22 0v-.765h-.437v.765a.548.548 0 0 0 1.094 0v-.765z"
        opacity={0.05}
      />
      <path
        fill="#000"
        d="M16.172 14.063v.765a.219.219 0 0 1-.438 0v-.765h-.218v.765a.438.438 0 0 0 .875 0v-.765z"
        opacity={0.07}
      />
      <path
        fill="#000"
        d="M20.656 14.063v.765a.11.11 0 0 1-.218 0v-.765H20v.765a.547.547 0 0 0 1.094 0v-.765z"
        opacity={0.05}
      />
      <path
        fill="#000"
        d="M20.766 14.063v.765a.219.219 0 0 1-.438 0v-.765h-.219v.765a.438.438 0 0 0 .875 0v-.765z"
        opacity={0.07}
      />
      <path
        fill="#54DAFF"
        d="M20.547 15.156a.33.33 0 0 1-.328-.328v-1.094a.328.328 0 1 1 .656 0v1.094a.33.33 0 0 1-.328.328M15.953 15.156a.33.33 0 0 1-.328-.328v-1.094a.328.328 0 0 1 .656 0v1.094a.33.33 0 0 1-.328.328"
      />
      <defs>
        <linearGradient
          id={_id}
          x1={16.609}
          x2={22.078}
          y1={5.891}
          y2={5.891}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#064484" />
          <stop offset={1} stopColor="#0F65B5" />
        </linearGradient>
        <linearGradient
          id={_id2}
          x1={22.625}
          x2={16.063}
          y1={7.805}
          y2={7.805}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#44DCFD" />
          <stop offset={0.453} stopColor="#259ED0" />
        </linearGradient>
        <linearGradient
          id={_id3}
          x1={16.063}
          x2={22.625}
          y1={7.805}
          y2={7.805}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#259ED0" />
          <stop offset={1} stopColor="#44DCFD" />
        </linearGradient>
        <linearGradient
          id={_id4}
          x1={13.875}
          x2={18.979}
          y1={6.073}
          y2={6.073}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#064484" />
          <stop offset={1} stopColor="#0F65B5" />
        </linearGradient>
        <linearGradient
          id={_id5}
          x1={2.769}
          x2={9.628}
          y1={20.552}
          y2={20.134}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2086B8" />
          <stop offset={1} stopColor="#46D3F6" />
        </linearGradient>
        <linearGradient
          id={_id6}
          x1={8.605}
          x2={10.524}
          y1={19.048}
          y2={17.707}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1694DB" />
          <stop offset={1} stopColor="#62C3FE" />
        </linearGradient>
        <linearGradient
          id={_id7}
          x1={3.998}
          x2={8.456}
          y1={15.338}
          y2={17.926}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D3D78" />
          <stop offset={1} stopColor="#063B83" />
        </linearGradient>
        <linearGradient
          id={_id8}
          x1={1.335}
          x2={5.818}
          y1={19.148}
          y2={17.484}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#16589B" />
          <stop offset={1} stopColor="#1464B7" />
        </linearGradient>
        <linearGradient
          id={_id9}
          x1={18.036}
          x2={18.483}
          y1={13.704}
          y2={16.697}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.042} stopColor="#076DB4" />
          <stop offset={0.85} stopColor="#0461AF" />
        </linearGradient>
        <linearGradient
          id={_id10}
          x1={17.733}
          x2={19.03}
          y1={14.154}
          y2={25.48}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#33BEF0" />
          <stop offset={1} stopColor="#0A85D9" />
        </linearGradient>
      </defs>
    </svg>
  );
};
const ForwardRef = React.forwardRef(MsSuiteDark);
export { ForwardRef as MsSuiteDark };
